import YGCClassPage from "./YGCClassPage";

const MEMBERS = [
  { name: "Shloka Ravinuthala", image: "/images/board-committees/ShlokaRavinuthala.jpg" },
  { name: "Claire Campbell", image: "/images/board-committees/ClaireCampbell.jpg" },
  { name: "Siddhi Hindurao", image: "/images/board-committees/SiddhiHindurao.jpg" },
  { name: "Shriyans Gurijala", image: "/images/base/Contact-1.png" },
  { name: "Reilley Owens", image: "/images/base/Contact-1.png" },
  { name: "Prathyum Reddy Bada", image: "/images/base/Contact-1.png" },
  { name: "Manu Gadhiraju", image: "/images/base/Contact-1.png" },
  { name: "Mahashvin (Hash) Vinothasha", image: "/images/base/Contact-1.png" },
  { name: "Lauren Cutler", image: "/images/base/Contact-1.png" },
  { name: "Avery Hedican", image: "/images/base/Contact-1.png" },
];

export default function Ygc2022() {
  return (
    <YGCClassPage
      year="2022"
      logoSrc="/images/ygc/2022/YGC_2022.jpg"
      photos={[
        { src: "/images/ygc/2022/2022-YGC-Graduates-scaled.jpg", caption: "Class of 2022 — Shloka Ravinuthala, Claire Campbell, Siddhi Hindurao, Shriyans Gurijala, Reilley Owens, Prathyum Reddy Bada, Manu Gadhiraju, Mahashvin (Hash) Vinothasha, Lauren Cutler, Avery Hedican" },
        { src: "/images/ygc/2022/2022-YGC-Team-CHCC-scaled.jpg", caption: "YGC project team that raised $6,078.18 for CHCC — Arjun Kumarakrishnan, Prathyum Reddy Bada, Theresa Lage, Lauren Cutler, Shloka Ravinuthala, Shriyans Gurijala, and Reilley Owens" },
        { src: "/images/ygc/2022/2022-YGC-Team-Integrity-scaled.jpg", caption: "YGC project team that raised $6,775.14 for Integrity Counseling — Siddhi Hindurao, Kristin Manzi, Manu Gadhiraju, Avery Hedican, Claire Campbell, and Mahashvin (Hash) Vinothasha" },
      ]}
      members={MEMBERS}
    />
  );
}